import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import Gdpr from '../../images/svg/gdpr.svg'
import iso27001 from '../../images/ISO27001.png'
import iso9001 from '../../images/ISO9001.png'

function Certificates() {
  return <div className='flex lg:gap-4 mt-9 items-start'>
        <Gdpr className='w-[53px] h-[45px] object-contain' />
        <img src={iso27001} className='w-10 object-contain' alt='ISO27001' />
        <img src={iso9001} className='w-10 object-contain' alt='ISO9001' />
    </div>
}

export default Certificates